"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var Message;
(function (Message) {
    Message["NetworkError"] = "It seems that your internet connection is unstable. Please check to see that you are connected to the internet and try again.";
})(Message || (exports.Message = Message = {}));
